import React from "react";

const Header = () => {
  return (
    <div className="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-white border-bottom box-shadow">
      <h5 className="my-0 mr-md-auto font-weight-normal">Image Search</h5>
      <a
        className="btn btn-outline-primary"
        href="https://github.com/prasathmani"
      >
        Github
      </a>
    </div>
  );
};

export default Header;
